import { render } from "./LoginRegisterPage.vue?vue&type=template&id=07127670&ts=true"
import script from "./LoginRegisterPage.vue?vue&type=script&lang=ts"
export * from "./LoginRegisterPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__